import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id E26942A0-61AE-4D1A-941C-895D92E94C5D
 * name glass-stange
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/glass-stange.svg
 * tags
 * - Food / Drink 
 */
export const GlassStangeIcon = createSvgIcon(<><path d="M8,2H16V22H8V2M10,4V7H14V4H10Z" /></>, 'GlassStangeIcon');
export default GlassStangeIcon